import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {ISurveySelected, ISurveySelectedEvent, SurveyFormItemComponentInterface} from '../../../../interface/component';
import {IAnswers, SurveyQuestionStructure} from '../survey/survey.component';
import {IHttpSetting} from '../../../../interface/dataset-params';
import {MatCheckboxChange} from '@angular/material/checkbox';

@Component({
    selector: 'noos-survey-checkboxlist',
    templateUrl: './survey-checkboxlist.component.html',
    styleUrls: ['./survey-checkboxlist.component.scss']
})

@NoosFormTypeService.register('survey-checkboxlist')
export class SurveyCheckboxlistComponent implements OnInit, AfterViewInit, SurveyFormItemComponentInterface {

    prop: SurveyQuestionStructure;
    isFilter = false;
    thisAppearance: any = 'outline';
    setting: IHttpSetting;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    @Input()
    index = 0;

    answers?: ISurveySelected[];
    isView = false;

    selectedValue: EventEmitter<ISurveySelectedEvent> = new EventEmitter<ISurveySelectedEvent>();

    selectedAnswers: ISurveySelected[] = [];

    constructor() {
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
    }

    onChecked($event: MatCheckboxChange, item: IAnswers) {
        if ($event.checked) {
            this.selectedAnswers.push({value: item.id, title: item.text, point: item.point});
        } else {
            this.selectedAnswers = this.selectedAnswers.filter(x => x.value !== item.id);
        }
        this.selectedValue.emit({question: this.prop, answers: this.selectedAnswers});
    }

    getChecked(item: IAnswers) {
        if (this.answers !== undefined) {
            return this.answers.filter(x => x.value === item.id).length > 0;
        }
        return false;
    }
}
